import { Md5 } from "ts-md5";

import { Image, ImageProps } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";

const WorkspaceIcon_Workspace = graphql(`
  fragment WorkspaceIcon_Workspace on Workspace {
    id
    name
    avatarUrl
  }
`);

interface Props {
  avatarUrl?: string;
  workspace: FragmentType<typeof WorkspaceIcon_Workspace>;
}

export default function WorkspaceIcon({
  workspace: propWorkspace,
  avatarUrl,
  ...imageProps
}: Props & ImageProps) {
  const workspace = getFragmentData(WorkspaceIcon_Workspace, propWorkspace);
  return (
    <Image
      ignoreFallback
      alt="avatar"
      borderRadius="md"
      height="30px"
      src={
        avatarUrl ||
        workspace.avatarUrl ||
        `https://www.gravatar.com/avatar/${Md5.hashStr(workspace.name)}?d=retro`
      }
      width="30px"
      {...imageProps}
    />
  );
}
